export { default as VictoryArea } from "./victory-area";
export { default as Area } from "./area";


//////////////////
// WEBPACK FOOTER
// ./~/victory-area/es/index.js
// module id = 2435
// module chunks = 0